import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const FilterContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FilterProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    segmento: '',
    regiao: '',
    porte: '',
    periodo: 2024,
    company_ids: '',
  });
  const [options, setOptions] = useState({ segmentos: [], regioes: [], portes: [], periodos: [], companies: [] });
  const [loading, setLoading] = useState(false);

  const fetchOptions = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const { data } = await axios.get(`${API}/filters/options`, { headers: { Authorization: `Bearer ${token}` } });
      setOptions(data);
    } catch (e) {
      console.error('Erro ao carregar filtros:', e);
    }
  }, []);

  useEffect(() => { fetchOptions(); }, [fetchOptions]);

  const buildQuery = useCallback(() => {
    const params = new URLSearchParams();
    if (filters.segmento) params.set('segmento', filters.segmento);
    if (filters.regiao) params.set('regiao', filters.regiao);
    if (filters.porte) params.set('porte', filters.porte);
    if (filters.periodo) params.set('periodo', filters.periodo);
    if (filters.company_ids) params.set('company_ids', filters.company_ids);
    return params.toString();
  }, [filters]);

  const updateFilter = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const resetFilters = () => {
    setFilters({ segmento: '', regiao: '', porte: '', periodo: 2024, company_ids: '' });
  };

  const fetchWithFilters = useCallback(async (endpoint) => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    setLoading(true);
    try {
      const qs = buildQuery();
      const url = `${API}${endpoint}${qs ? '?' + qs : ''}`;
      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      return data;
    } catch (e) {
      if (e.response?.status === 403) {
        return { blocked: true, detail: e.response.data.detail };
      }
      throw e;
    } finally {
      setLoading(false);
    }
  }, [buildQuery]);

  return (
    <FilterContext.Provider value={{ filters, options, loading, updateFilter, resetFilters, fetchWithFilters, buildQuery, fetchOptions }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilters = () => {
  const ctx = useContext(FilterContext);
  if (!ctx) throw new Error('useFilters must be used within FilterProvider');
  return ctx;
};
